/* eslint-env jquery */
import { stepsClick, stepsMatchHeight } from './steps.js';
const $ = jQuery;
if ($('.product-steps').length) {
  $(document).ready(projectStepsInit);
  $(window).on('resize', stepsMatchHeight('product-steps', 1));
}

function projectStepsInit() {
  stepsClick('product-steps');
  stepsMatchHeight('product-steps', 1);
}
